import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../../components/Layout'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle,faHouseUser, faBullhorn, faComments, faUserTie } from '@fortawesome/free-solid-svg-icons'
import { graphql } from 'gatsby'
import { useIntl } from "@intractive/gatsby-plugin-react-intl"

const MeedoenPage = ({ data }) => {
  const page = data.meedoenpagina
  const { title, metaDescription, text} = page
  const intl = useIntl();
  
  return(
    <Layout>
      <Helmet>
          <title>{title} · STIP</title>
          <meta name="description" content={metaDescription} />
        </Helmet>
      <div className="row main-content">
        <div className="columns">
          <section>
            <h1>{title}</h1>
            <div>              
              <div>
                <div dangerouslySetInnerHTML={{__html: text.childMarkdownRemark.html,}}/>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  )
}

export default MeedoenPage

export const query = graphql`
  query($node_locale: String) {
    meedoenpagina: contentfulPage(slug: {eq: "meedoen"}, node_locale: {eq: $node_locale}) {
      title
      metaDescription
      pageTitle
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`
